import { createSlice } from "@reduxjs/toolkit";
import {
  MissionAndVisionData,
  MissionAndVisionDataInitialStatus,
} from "../../../../../types/webCms/aboutUs/MissionVission";
import {
  getAllMissionAndVisionAsync,
  updateMissionAndVisionDataAsync,
} from "./missionApi";

const initialState: MissionAndVisionDataInitialStatus<MissionAndVisionData> = {
  loading: false,
  manageLoading: false,
  missionAndVisionDataList: [],
  countMissionAndVisionData: 0,
};

const missionAndVisionSlice = createSlice({
  name: "admin-mission-vision",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllMissionAndVisionAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllMissionAndVisionAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.missionAndVisionDataList = action.payload.data;
        state.countMissionAndVisionData = action.payload.length;
      })
      .addCase(getAllMissionAndVisionAsync.rejected, (state) => {
        state.loading = false;
        state.missionAndVisionDataList = [];
        state.countMissionAndVisionData = 0;
      });

    // update
    builder
      .addCase(updateMissionAndVisionDataAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateMissionAndVisionDataAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateMissionAndVisionDataAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default missionAndVisionSlice;
